var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page",class:_vm.$darkMode.get() ? 'bg-dark-svg' : 'bg-light-svg'},[_c('div',{staticClass:"full-page",class:_vm.pageClass},[_c('notifications'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('nuxt')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }